var map = {
	"./action-card-lapis.svg": 966,
	"./action-card-liquidity-mining-btc-dfi.svg": 967,
	"./action-card-liquidity-mining-eth-dfi.svg": 968,
	"./action-card-liquidity-mining-generic.svg": 969,
	"./action-card-liquidity-mining-usdt-dfi.svg": 970,
	"./action-card-staking.svg": 702,
	"./actionlock.svg": 971,
	"./affiliate-feature-bonus.svg": 358,
	"./affiliate-feature-tracking.svg": 359,
	"./affiliate-feature-unlimited.svg": 360,
	"./bakePro/bake-pro-logo.svg": 679,
	"./bakePro/bake-white-logo-with-text.svg": 680,
	"./bakePro/bake-white-logo.svg": 972,
	"./bg-elite-full.svg": 690,
	"./bg-elite.svg": 703,
	"./borrowing-hero.svg": 973,
	"./cake-elite-black.svg": 691,
	"./cake-elite-close.svg": 681,
	"./cake-elite-free-withdrawal.svg": 704,
	"./cake-elite.svg": 705,
	"./cake-razer-catalog-redeem.svg": 706,
	"./cake-razer-connect.svg": 707,
	"./cake-razer-redeem-voucher.svg": 708,
	"./cakenode-logo.svg": 974,
	"./check-mark.svg": 975,
	"./clear-button.svg": 976,
	"./close-button.svg": 361,
	"./coins/icon-coin-1inch.svg": 977,
	"./coins/icon-coin-aave.svg": 978,
	"./coins/icon-coin-ada.svg": 979,
	"./coins/icon-coin-aero.svg": 980,
	"./coins/icon-coin-aioz.svg": 981,
	"./coins/icon-coin-akt.svg": 982,
	"./coins/icon-coin-algo.svg": 983,
	"./coins/icon-coin-ape.svg": 984,
	"./coins/icon-coin-api3.svg": 985,
	"./coins/icon-coin-apt.svg": 986,
	"./coins/icon-coin-ar.svg": 987,
	"./coins/icon-coin-arb.svg": 988,
	"./coins/icon-coin-arkm.svg": 989,
	"./coins/icon-coin-atlas.svg": 990,
	"./coins/icon-coin-atom.svg": 991,
	"./coins/icon-coin-audio.svg": 992,
	"./coins/icon-coin-avax.svg": 993,
	"./coins/icon-coin-axl.svg": 994,
	"./coins/icon-coin-axs.svg": 995,
	"./coins/icon-coin-band.svg": 996,
	"./coins/icon-coin-bat.svg": 997,
	"./coins/icon-coin-bch.svg": 998,
	"./coins/icon-coin-benji.svg": 999,
	"./coins/icon-coin-blur.svg": 1000,
	"./coins/icon-coin-bnx.svg": 1001,
	"./coins/icon-coin-bonk.svg": 1002,
	"./coins/icon-coin-brett.svg": 1003,
	"./coins/icon-coin-btc.svg": 1004,
	"./coins/icon-coin-btg.svg": 1005,
	"./coins/icon-coin-btt.svg": 1006,
	"./coins/icon-coin-cake.svg": 1007,
	"./coins/icon-coin-celo.svg": 1008,
	"./coins/icon-coin-cfg.svg": 1009,
	"./coins/icon-coin-chaincoin.svg": 1010,
	"./coins/icon-coin-chz.svg": 1011,
	"./coins/icon-coin-comp.svg": 1012,
	"./coins/icon-coin-coq.svg": 1013,
	"./coins/icon-coin-core.svg": 1014,
	"./coins/icon-coin-crv.svg": 1015,
	"./coins/icon-coin-cseth.svg": 1016,
	"./coins/icon-coin-cspr.svg": 1017,
	"./coins/icon-coin-cvx.svg": 1018,
	"./coins/icon-coin-cwif.svg": 1019,
	"./coins/icon-coin-dash.svg": 1020,
	"./coins/icon-coin-decentralized.svg": 1021,
	"./coins/icon-coin-degen.svg": 1022,
	"./coins/icon-coin-dfi.svg": 1023,
	"./coins/icon-coin-dia.svg": 1024,
	"./coins/icon-coin-dodo.svg": 1025,
	"./coins/icon-coin-dog.svg": 1026,
	"./coins/icon-coin-doge-alt.svg": 1027,
	"./coins/icon-coin-doge.svg": 1028,
	"./coins/icon-coin-dot.svg": 1029,
	"./coins/icon-coin-dydx.svg": 1030,
	"./coins/icon-coin-egld.svg": 1031,
	"./coins/icon-coin-elf.svg": 1032,
	"./coins/icon-coin-ena.svg": 1033,
	"./coins/icon-coin-enj.svg": 1034,
	"./coins/icon-coin-ens.svg": 1035,
	"./coins/icon-coin-eos.svg": 1036,
	"./coins/icon-coin-eth.svg": 1037,
	"./coins/icon-coin-euroc.svg": 1038,
	"./coins/icon-coin-fet.svg": 1039,
	"./coins/icon-coin-fil.svg": 1040,
	"./coins/icon-coin-floki.svg": 1041,
	"./coins/icon-coin-flow.svg": 1042,
	"./coins/icon-coin-flux.svg": 1043,
	"./coins/icon-coin-ftm.svg": 1044,
	"./coins/icon-coin-gala.svg": 1045,
	"./coins/icon-coin-gfi.svg": 1046,
	"./coins/icon-coin-glm.svg": 1047,
	"./coins/icon-coin-gmt.svg": 1048,
	"./coins/icon-coin-gno.svg": 1049,
	"./coins/icon-coin-grt.svg": 1050,
	"./coins/icon-coin-hbar.svg": 1051,
	"./coins/icon-coin-hnt.svg": 1052,
	"./coins/icon-coin-icp.svg": 1053,
	"./coins/icon-coin-ilv.svg": 1054,
	"./coins/icon-coin-imx.svg": 1055,
	"./coins/icon-coin-inj.svg": 1056,
	"./coins/icon-coin-jasmy.svg": 1057,
	"./coins/icon-coin-jav.svg": 1058,
	"./coins/icon-coin-joe.svg": 1059,
	"./coins/icon-coin-jup.svg": 1060,
	"./coins/icon-coin-kas.svg": 1061,
	"./coins/icon-coin-ldo.svg": 1062,
	"./coins/icon-coin-link.svg": 1063,
	"./coins/icon-coin-lobo.svg": 1064,
	"./coins/icon-coin-lpt.svg": 1065,
	"./coins/icon-coin-lrc.svg": 1066,
	"./coins/icon-coin-ltc.svg": 1067,
	"./coins/icon-coin-magic.svg": 1068,
	"./coins/icon-coin-mana.svg": 1069,
	"./coins/icon-coin-matic.svg": 1070,
	"./coins/icon-coin-mew.svg": 1071,
	"./coins/icon-coin-mkr.svg": 1072,
	"./coins/icon-coin-mock.svg": 1073,
	"./coins/icon-coin-mog.svg": 1074,
	"./coins/icon-coin-mpl.svg": 1075,
	"./coins/icon-coin-myth.svg": 1076,
	"./coins/icon-coin-near.svg": 1077,
	"./coins/icon-coin-nmr.svg": 1078,
	"./coins/icon-coin-not.svg": 1079,
	"./coins/icon-coin-nrg.svg": 1080,
	"./coins/icon-coin-ntrn.svg": 1081,
	"./coins/icon-coin-ocean.svg": 1082,
	"./coins/icon-coin-om.svg": 1083,
	"./coins/icon-coin-ondo.svg": 1084,
	"./coins/icon-coin-op.svg": 1085,
	"./coins/icon-coin-orai.svg": 1086,
	"./coins/icon-coin-osmo.svg": 1087,
	"./coins/icon-coin-paxg.svg": 1088,
	"./coins/icon-coin-pendle.svg": 1089,
	"./coins/icon-coin-peng.svg": 1090,
	"./coins/icon-coin-pepe.svg": 1091,
	"./coins/icon-coin-pivx.svg": 1092,
	"./coins/icon-coin-pol.svg": 1093,
	"./coins/icon-coin-ponke.svg": 1094,
	"./coins/icon-coin-popcat.svg": 1095,
	"./coins/icon-coin-prime.svg": 1096,
	"./coins/icon-coin-pro.svg": 1097,
	"./coins/icon-coin-pyth.svg": 1098,
	"./coins/icon-coin-qnt.svg": 1099,
	"./coins/icon-coin-ray.svg": 1100,
	"./coins/icon-coin-rndr.svg": 1101,
	"./coins/icon-coin-ron.svg": 1102,
	"./coins/icon-coin-rpl.svg": 1103,
	"./coins/icon-coin-rsic.svg": 1104,
	"./coins/icon-coin-rune.svg": 1105,
	"./coins/icon-coin-s.svg": 1106,
	"./coins/icon-coin-sand.svg": 1107,
	"./coins/icon-coin-satoshi.svg": 1108,
	"./coins/icon-coin-sei.svg": 1109,
	"./coins/icon-coin-shib.svg": 1110,
	"./coins/icon-coin-sins.svg": 1111,
	"./coins/icon-coin-skl.svg": 1112,
	"./coins/icon-coin-snx.svg": 1113,
	"./coins/icon-coin-sol.svg": 1114,
	"./coins/icon-coin-storj.svg": 1115,
	"./coins/icon-coin-strk.svg": 1116,
	"./coins/icon-coin-stx.svg": 1117,
	"./coins/icon-coin-sui.svg": 1118,
	"./coins/icon-coin-super.svg": 1119,
	"./coins/icon-coin-syscoin.svg": 1120,
	"./coins/icon-coin-tao.svg": 1121,
	"./coins/icon-coin-tbill.svg": 1122,
	"./coins/icon-coin-theta.svg": 1123,
	"./coins/icon-coin-tia.svg": 1124,
	"./coins/icon-coin-ton.svg": 1125,
	"./coins/icon-coin-trac.svg": 1126,
	"./coins/icon-coin-trb.svg": 1127,
	"./coins/icon-coin-tru.svg": 1128,
	"./coins/icon-coin-trx.svg": 1129,
	"./coins/icon-coin-turbo.svg": 1130,
	"./coins/icon-coin-uma.svg": 1131,
	"./coins/icon-coin-uncommongoods.svg": 1132,
	"./coins/icon-coin-uni.svg": 1133,
	"./coins/icon-coin-usdc.svg": 1134,
	"./coins/icon-coin-usdt.svg": 1135,
	"./coins/icon-coin-van.svg": 1136,
	"./coins/icon-coin-velo.svg": 1137,
	"./coins/icon-coin-w.svg": 1138,
	"./coins/icon-coin-wif.svg": 1139,
	"./coins/icon-coin-woo.svg": 1140,
	"./coins/icon-coin-xaut.svg": 1141,
	"./coins/icon-coin-xlm.svg": 1142,
	"./coins/icon-coin-xmas-btc.svg": 1143,
	"./coins/icon-coin-xrp.svg": 1144,
	"./coins/icon-coin-xtz.svg": 1145,
	"./coins/icon-coin-xzc.svg": 1146,
	"./coins/icon-coin-ygg.svg": 1147,
	"./coins/icon-coin-zeta.svg": 1148,
	"./coins/icon-coin-zil.svg": 1149,
	"./coins/icon-coin-zk.svg": 1150,
	"./confectionery-badge-profile-image-wrapper.svg": 1151,
	"./confectionery-badge-waves.svg": 1152,
	"./confectionists-apprentice.svg": 1153,
	"./confectionists-confectionist.svg": 1154,
	"./confectionists-master-baker.svg": 1155,
	"./confectionists.svg": 1156,
	"./currencies/afn.svg": 1157,
	"./currencies/ang.svg": 1158,
	"./currencies/chf.svg": 1159,
	"./currencies/cny.svg": 1160,
	"./currencies/crc.svg": 1161,
	"./currencies/eur.svg": 1162,
	"./currencies/gbp.svg": 1163,
	"./currencies/gtq.svg": 1164,
	"./currencies/idr.svg": 1165,
	"./currencies/ils.svg": 1166,
	"./currencies/inr.svg": 1167,
	"./currencies/irr.svg": 1168,
	"./currencies/jpy.svg": 1169,
	"./currencies/krw.svg": 1170,
	"./currencies/kzt.svg": 1171,
	"./currencies/lak.svg": 1172,
	"./currencies/ltl.svg": 1173,
	"./currencies/lvl.svg": 1174,
	"./currencies/mnt.svg": 1175,
	"./currencies/myr.svg": 1176,
	"./currencies/ngn.svg": 1177,
	"./currencies/pab.svg": 1178,
	"./currencies/pen.svg": 1179,
	"./currencies/php.svg": 1180,
	"./currencies/pln.svg": 1181,
	"./currencies/pyg.svg": 1182,
	"./currencies/ron.svg": 1183,
	"./currencies/rsd.svg": 1184,
	"./currencies/rub.svg": 1185,
	"./currencies/thb.svg": 1186,
	"./currencies/try.svg": 1187,
	"./currencies/uah.svg": 1188,
	"./currencies/usd.svg": 1189,
	"./currencies/vnd.svg": 1190,
	"./currencies/yer.svg": 1191,
	"./defichain-dex-swap.svg": 709,
	"./defichain-logo.svg": 1192,
	"./dexFrom.svg": 1193,
	"./dfi-razer-silver-freezer.svg": 1194,
	"./dropdown-caret.svg": 1195,
	"./error-warning.svg": 362,
	"./ethLuckyDraw/minus-icon.svg": 692,
	"./ethLuckyDraw/plus-icon.svg": 693,
	"./fiat-btc-dfi.svg": 225,
	"./freezer-empty.svg": 682,
	"./freezer-hero-01.svg": 1196,
	"./freezer-hero-lunar.svg": 1197,
	"./freezer-hero.svg": 1198,
	"./freezer/step1.svg": 1199,
	"./freezer/step2.svg": 1200,
	"./freezer/step3.svg": 1201,
	"./gift-card-hero.svg": 710,
	"./gift-card.svg": 1202,
	"./hero-illustration-1.svg": 1203,
	"./hero-illustration-2.svg": 1204,
	"./hero-illustration-3.svg": 1205,
	"./hero-liquidity-mining-home.svg": 1206,
	"./hero-liquidity-mining-promo.svg": 1207,
	"./hero-liquidity-mining.svg": 1208,
	"./icon-alert.svg": 363,
	"./icon-arrow-down.svg": 364,
	"./icon-arrow-forward.svg": 365,
	"./icon-arrow-up.svg": 366,
	"./icon-automation.svg": 1209,
	"./icon-check.svg": 367,
	"./icon-clock.svg": 368,
	"./icon-close.svg": 350,
	"./icon-copy.svg": 369,
	"./icon-error.svg": 370,
	"./icon-eye-close.svg": 371,
	"./icon-eye-open.svg": 372,
	"./icon-freedom.svg": 1210,
	"./icon-grain.svg": 1211,
	"./icon-green-check.svg": 373,
	"./icon-hamburger.svg": 374,
	"./icon-help-electricberry.svg": 1212,
	"./icon-help.svg": 375,
	"./icon-info-dark.svg": 711,
	"./icon-info-gray-solid.svg": 376,
	"./icon-info-orange.svg": 712,
	"./icon-info.svg": 149,
	"./icon-link.svg": 1213,
	"./icon-more.svg": 377,
	"./icon-next.svg": 378,
	"./icon-nodes.svg": 1214,
	"./icon-oven-mode-compact.svg": 379,
	"./icon-oven-mode-normal.svg": 380,
	"./icon-password.svg": 1215,
	"./icon-phone.svg": 345,
	"./icon-play-circle.svg": 381,
	"./icon-pledge.svg": 1216,
	"./icon-prev.svg": 382,
	"./icon-proof.svg": 287,
	"./icon-save.svg": 383,
	"./icon-search.svg": 384,
	"./icon-sort-down.svg": 385,
	"./icon-sort-up.svg": 386,
	"./icon-telegram.svg": 713,
	"./icon-trade.svg": 387,
	"./icon-transparency.svg": 1217,
	"./icon-warning.svg": 388,
	"./kyc/kyc-bank-statement.svg": 1218,
	"./kyc/kyc-benefit-icon.svg": 389,
	"./kyc/kyc-drivers-license.svg": 1219,
	"./kyc/kyc-exclaimation-icon.svg": 346,
	"./kyc/kyc-gov-doc.svg": 1220,
	"./kyc/kyc-id.svg": 1221,
	"./kyc/kyc-in-review-icon.svg": 226,
	"./kyc/kyc-passport.svg": 1222,
	"./kyc/kyc-phone-bill.svg": 1223,
	"./kyc/kyc-phone.svg": 390,
	"./kyc/kyc-rejected-icon.svg": 227,
	"./kyc/kyc-selfie-id.svg": 1224,
	"./kyc/kyc-selfie-illustration-bad-de.svg": 1225,
	"./kyc/kyc-selfie-illustration-bad-en.svg": 1226,
	"./kyc/kyc-selfie-illustration-bad-it.svg": 1227,
	"./kyc/kyc-selfie-illustration-bad-zh.svg": 1228,
	"./kyc/kyc-selfie-illustration-bad.svg": 1229,
	"./kyc/kyc-selfie-illustration-good-de.svg": 1230,
	"./kyc/kyc-selfie-illustration-good-en.svg": 1231,
	"./kyc/kyc-selfie-illustration-good-it.svg": 1232,
	"./kyc/kyc-selfie-illustration-good-zh.svg": 1233,
	"./kyc/kyc-selfie-illustration-good.svg": 1234,
	"./kyc/kyc-selfie-illustration.svg": 1235,
	"./kyc/kyc-unverified-icon.svg": 391,
	"./kyc/kyc-upload.svg": 1236,
	"./kyc/kyc-utility-bill.svg": 1237,
	"./kyc/kyc-verified-icon.svg": 167,
	"./kyc/kyc-warning-icon.svg": 228,
	"./kyc/kyc-webcam.svg": 1238,
	"./kyc/lock-icon.svg": 714,
	"./kyc/lolipop-icon.svg": 1239,
	"./kyc/myinfo-inline-primary.svg": 694,
	"./kyc/myinfo-stacked-primary.svg": 715,
	"./kyc/singpass-logo.svg": 695,
	"./lapis-hero-home.svg": 1240,
	"./lapis-hero.svg": 1241,
	"./learnEarn/btcQuiz/btc-cover.svg": 392,
	"./learnEarn/btcQuiz/lesson-1/l1-p1.svg": 393,
	"./learnEarn/btcQuiz/lesson-1/l1-p2.svg": 394,
	"./learnEarn/btcQuiz/lesson-1/l1-p3.svg": 395,
	"./learnEarn/btcQuiz/lesson-1/l1-p4.svg": 396,
	"./learnEarn/btcQuiz/lesson-1/l1-p5.svg": 397,
	"./learnEarn/btcQuiz/lesson-1/l1-p6.svg": 398,
	"./learnEarn/btcQuiz/lesson-2/l2-p1.svg": 399,
	"./learnEarn/btcQuiz/lesson-2/l2-p2.svg": 400,
	"./learnEarn/btcQuiz/lesson-2/l2-p3.svg": 401,
	"./learnEarn/btcQuiz/lesson-2/l2-p4.svg": 402,
	"./learnEarn/btcQuiz/lesson-2/l2-p5.svg": 403,
	"./learnEarn/btcQuiz/lesson-2/l2-p6.svg": 404,
	"./learnEarn/btcQuiz/lesson-3/l3-p1.svg": 405,
	"./learnEarn/btcQuiz/lesson-3/l3-p2.svg": 406,
	"./learnEarn/btcQuiz/lesson-3/l3-p3.svg": 407,
	"./learnEarn/btcQuiz/lesson-3/l3-p4.svg": 408,
	"./learnEarn/btcQuiz/lesson-3/l3-p5.svg": 409,
	"./learnEarn/btcQuiz/lesson-3/l3-p6.svg": 410,
	"./learnEarn/btcQuiz/lesson-4/l4-p1.svg": 411,
	"./learnEarn/btcQuiz/lesson-4/l4-p2.svg": 412,
	"./learnEarn/btcQuiz/lesson-4/l4-p3.svg": 413,
	"./learnEarn/btcQuiz/lesson-4/l4-p4.svg": 414,
	"./learnEarn/btcQuiz/lesson-4/l4-p5.svg": 415,
	"./learnEarn/btcQuiz/lesson-4/l4-p6.svg": 416,
	"./learnEarn/btcQuiz/lesson-5/l5-p1.svg": 417,
	"./learnEarn/btcQuiz/lesson-5/l5-p2.svg": 418,
	"./learnEarn/btcQuiz/lesson-5/l5-p3.svg": 419,
	"./learnEarn/btcQuiz/lesson-5/l5-p4.svg": 420,
	"./learnEarn/btcQuiz/lesson-5/l5-p5.svg": 421,
	"./learnEarn/btcQuiz/lesson-5/l5-p6.svg": 422,
	"./learnEarn/confetti.svg": 423,
	"./learnEarn/dfiQuiz/dfi-cover.svg": 424,
	"./learnEarn/dfiQuiz/lesson-1/l1-p1.svg": 425,
	"./learnEarn/dfiQuiz/lesson-1/l1-p2.svg": 426,
	"./learnEarn/dfiQuiz/lesson-1/l1-p3.svg": 427,
	"./learnEarn/dfiQuiz/lesson-1/l1-p4.svg": 428,
	"./learnEarn/dfiQuiz/lesson-1/l1-p5.svg": 429,
	"./learnEarn/dfiQuiz/lesson-1/l1-p6.svg": 430,
	"./learnEarn/dfiQuiz/lesson-2/l2-p1.svg": 431,
	"./learnEarn/dfiQuiz/lesson-2/l2-p2.svg": 432,
	"./learnEarn/dfiQuiz/lesson-2/l2-p3.svg": 433,
	"./learnEarn/dfiQuiz/lesson-2/l2-p4.svg": 434,
	"./learnEarn/dfiQuiz/lesson-2/l2-p5.svg": 435,
	"./learnEarn/dfiQuiz/lesson-2/l2-p6.svg": 436,
	"./learnEarn/dfiQuiz/lesson-3/l3-p1.svg": 437,
	"./learnEarn/dfiQuiz/lesson-3/l3-p2.svg": 438,
	"./learnEarn/dfiQuiz/lesson-3/l3-p3.svg": 439,
	"./learnEarn/dfiQuiz/lesson-3/l3-p4.svg": 440,
	"./learnEarn/dfiQuiz/lesson-3/l3-p5.svg": 441,
	"./learnEarn/dfiQuiz/lesson-3/l3-p6.svg": 442,
	"./learnEarn/dfiQuiz/lesson-4/l4-p1.svg": 443,
	"./learnEarn/dfiQuiz/lesson-4/l4-p2.svg": 444,
	"./learnEarn/dfiQuiz/lesson-4/l4-p3.svg": 445,
	"./learnEarn/dfiQuiz/lesson-4/l4-p4.svg": 446,
	"./learnEarn/dfiQuiz/lesson-4/l4-p5.svg": 447,
	"./learnEarn/dfiQuiz/lesson-4/l4-p6.svg": 448,
	"./learnEarn/dfiQuiz/lesson-5/l5-p1.svg": 449,
	"./learnEarn/dfiQuiz/lesson-5/l5-p2.svg": 450,
	"./learnEarn/dfiQuiz/lesson-5/l5-p3.svg": 451,
	"./learnEarn/dfiQuiz/lesson-5/l5-p4.svg": 452,
	"./learnEarn/dfiQuiz/lesson-5/l5-p5.svg": 453,
	"./learnEarn/dfiQuiz/lesson-5/l5-p6.svg": 454,
	"./learnEarn/learn-earn-hero-toaster.svg": 716,
	"./lending-not-available.svg": 1242,
	"./liquidity-mining-empty.svg": 683,
	"./list.svg": 455,
	"./logos/access-industry-member.svg": 456,
	"./logos/action-card-staking.svg": 1243,
	"./logos/bake-logo.svg": 457,
	"./logos/banxa-logo.svg": 458,
	"./logos/logo-cakedefi-2line.svg": 1244,
	"./logos/logo-cakedefi-compact.svg": 1245,
	"./logos/logo-cakedefi.svg": 1246,
	"./logos/qr-icon.svg": 1247,
	"./mail-close-icon.svg": 459,
	"./mail-popup-banner-icon.svg": 460,
	"./mailbox.svg": 461,
	"./marketing-real-estate-freezer-background.svg": 1248,
	"./marketing-real-estate-freezer.svg": 1249,
	"./marketing-real-estate-welcome-bonus-background.svg": 1250,
	"./marketing-real-estate-welcome-bonus.svg": 1251,
	"./marketing/marketing-real-estate-welcome-bonus-background.svg": 696,
	"./mobile-download-qr.svg": 220,
	"./mobile-interface-porfolio.svg": 697,
	"./mobile-interface-screen.svg": 229,
	"./networks/icon-network-bitcoin.svg": 1252,
	"./networks/icon-network-bitcoin_cash.svg": 1253,
	"./networks/icon-network-cardano.svg": 1254,
	"./networks/icon-network-dash.svg": 1255,
	"./networks/icon-network-defi_metachain.svg": 1256,
	"./networks/icon-network-defichain.svg": 1257,
	"./networks/icon-network-disco.svg": 1258,
	"./networks/icon-network-dogecoin.svg": 1259,
	"./networks/icon-network-energi.svg": 1260,
	"./networks/icon-network-ethereum.svg": 1261,
	"./networks/icon-network-litecoin.svg": 1262,
	"./networks/icon-network-mock.svg": 1263,
	"./networks/icon-network-near.svg": 1264,
	"./networks/icon-network-pivx.svg": 1265,
	"./networks/icon-network-polkadot.svg": 1266,
	"./networks/icon-network-polygon.svg": 1267,
	"./networks/icon-network-safeinsure.svg": 1268,
	"./networks/icon-network-solana.svg": 1269,
	"./networks/icon-network-sui.svg": 1270,
	"./networks/icon-network-tron.svg": 1271,
	"./networks/icon-network-zcoin.svg": 1272,
	"./onboard-identity.svg": 230,
	"./onboarding/onboard-clipboard.svg": 1273,
	"./onboarding/onboard-identity.svg": 1274,
	"./onboarding/onboard-tour.svg": 1275,
	"./oven-mode-compact.svg": 1276,
	"./oven-mode-normal.svg": 1277,
	"./promoBanners/freezer-5-bonus.svg": 1278,
	"./promoBanners/liquidity-mining-thumbnail.svg": 1279,
	"./promoBanners/promo-banner-11-11-2022.svg": 1280,
	"./promoBanners/promo-banner-11-11.svg": 1281,
	"./promoBanners/promo-banner-ETH-staking.svg": 1282,
	"./promoBanners/promo-banner-black-friday.svg": 1283,
	"./promoBanners/promo-banner-easter.svg": 1284,
	"./promoBanners/promo-banner-freezer-lunar.svg": 1285,
	"./promoBanners/promo-banner-freezer.svg": 1286,
	"./promoBanners/promo-banner-learn-earn.svg": 1287,
	"./promoBanners/promo-banner-lending.svg": 1288,
	"./promoBanners/promo-banner-liquidity-mining.svg": 1289,
	"./promoBanners/promo-banner-loans.svg": 1290,
	"./promoBanners/promo-banner-razer.svg": 1291,
	"./promoBanners/promo-banner-referral.svg": 1292,
	"./promoBanners/promo-banner-stable-coin-liquidity-mining.svg": 1293,
	"./promoBanners/promo-banner-staking.svg": 1294,
	"./promoBanners/promo-banner-tiger-lunar.svg": 1295,
	"./promoBanners/promo-banner-transak.svg": 1296,
	"./promoBanners/promo-banner-transparency.svg": 1297,
	"./promoBanners/promo-xmas-banner.svg": 1298,
	"./promoBanners/third-anniversary-thumbnail.svg": 1299,
	"./promoBanners/third-anniversary.svg": 1300,
	"./qr-code.svg": 1301,
	"./radio-mark.svg": 1302,
	"./razer-button.svg": 717,
	"./razer-logo.svg": 1303,
	"./razer-zsilver.svg": 1304,
	"./referral-confetti-sprinkles.svg": 718,
	"./referral-empty.svg": 684,
	"./referral-trophy.svg": 719,
	"./referral/black-friday-hero.svg": 1305,
	"./referral/easter-egg-blue.svg": 462,
	"./referral/easter-egg-gold.svg": 463,
	"./referral/easter-egg-green.svg": 464,
	"./referral/easter-egg-red.svg": 465,
	"./referral/easter-hero-0.svg": 466,
	"./referral/easter-hero-1.svg": 467,
	"./referral/easter-hero-2.svg": 468,
	"./referral/easter-hero-3.svg": 469,
	"./referral/easter-hero-4.svg": 470,
	"./referral/easter-hero-left.svg": 471,
	"./referral/eleven-eleven.svg": 472,
	"./referral/mooncake-hero-zhs.svg": 1306,
	"./referral/mooncake-hero-zht.svg": 1307,
	"./referral/mooncake-progress-1-4.svg": 1308,
	"./referral/mooncake-progress-2-4.svg": 1309,
	"./referral/mooncake-progress-3-4.svg": 1310,
	"./referral/mooncake-progress-4-4.svg": 1311,
	"./referral/oktoberfest-hero.svg": 1312,
	"./referral/oktoberfest-progress-1-4.svg": 1313,
	"./referral/oktoberfest-progress-2-4.svg": 1314,
	"./referral/oktoberfest-progress-3-4.svg": 1315,
	"./referral/oktoberfest-progress-4-4.svg": 1316,
	"./referral/olympic-bake-off-medal-bronze.svg": 1317,
	"./referral/olympic-bake-off-medal-gold.svg": 1318,
	"./referral/olympic-bake-off-medal-none.svg": 1319,
	"./referral/olympic-bake-off-medal-silver.svg": 1320,
	"./referral/olympic-bake-off-medal-world-record.svg": 1321,
	"./referral/tiger-lunar-hero.svg": 473,
	"./social-facebook.svg": 474,
	"./social-linkedin.svg": 475,
	"./social-reddit.svg": 476,
	"./social-twitter.svg": 477,
	"./social-youtube.svg": 478,
	"./sso/apple-sso-next.svg": 685,
	"./sso/icon-apple-logo.svg": 314,
	"./sso/icon-facebook-black.svg": 1322,
	"./sso/icon-facebook-profile.svg": 1323,
	"./sso/icon-facebook.svg": 1324,
	"./sso/icon-google-profile.svg": 698,
	"./sso/icon-google.svg": 315,
	"./staking-hero-home.svg": 1325,
	"./staking-hero.svg": 720,
	"./staking-snowflake.svg": 721,
	"./store/android.svg": 687,
	"./store/apple.svg": 688,
	"./store/qrcode.svg": 689,
	"./support-hero.svg": 722,
	"./texture-dotted.svg": 1326,
	"./tokens/aapl.svg": 1327,
	"./tokens/amd.svg": 1328,
	"./tokens/amzn.svg": 1329,
	"./tokens/arkk.svg": 1330,
	"./tokens/baba.svg": 1331,
	"./tokens/coin.svg": 1332,
	"./tokens/eem.svg": 1333,
	"./tokens/fb.svg": 1334,
	"./tokens/gld.svg": 1335,
	"./tokens/gme.svg": 1336,
	"./tokens/googl.svg": 1337,
	"./tokens/msft.svg": 1338,
	"./tokens/nvda.svg": 1339,
	"./tokens/pdbc.svg": 1340,
	"./tokens/pltr.svg": 1341,
	"./tokens/qqq.svg": 1342,
	"./tokens/slv.svg": 1343,
	"./tokens/spy.svg": 1344,
	"./tokens/tlt.svg": 1345,
	"./tokens/tsla.svg": 1346,
	"./tokens/twtr.svg": 1347,
	"./tokens/urth.svg": 1348,
	"./tokens/usd.svg": 1349,
	"./tokens/vnq.svg": 1350,
	"./transaction-empty.svg": 686,
	"./transfer-network-confirmation-fail.svg": 723,
	"./transfer-network-confirmation-pass.svg": 724,
	"./transparency-empty-lock.svg": 1351,
	"./transparency-hero.svg": 1352,
	"./transparency-step-1.svg": 1353,
	"./transparency-step-2.svg": 1354,
	"./transparency-step-3.svg": 1355,
	"./updates-info-icon.svg": 312,
	"./wallet/wallet-product-borrow.svg": 1356,
	"./wallet/wallet-product-earn.svg": 1357,
	"./wallet/wallet-product-freezer.svg": 1358,
	"./wallet/wallet-product-learn-and-earn.svg": 725,
	"./wallet/wallet-product-lending.svg": 1359,
	"./wallet/wallet-product-liquidity-mining.svg": 1360,
	"./wallet/wallet-product-referral.svg": 726,
	"./wallet/wallet-product-staking.svg": 727,
	"./wallet/wallet-product-yield-vault.svg": 1361,
	"./wave-loader.svg": 1362,
	"./welcome/2x-app-store.svg": 479,
	"./welcome/2x-google-play.svg": 480,
	"./welcome/app-store.svg": 481,
	"./welcome/banner-back.svg": 482,
	"./welcome/banner.svg": 483,
	"./welcome/google-play.svg": 484,
	"./welcome/qr-code.svg": 485,
	"./welcome/rated.svg": 1363,
	"./welcome/video-play-button.svg": 1364,
	"./xmas-background.svg": 1365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 965;